import { create } from 'zustand';
import apiClient from '../utils/apiClient';

export const useVersionStore = create((set, get) => ({
  version: null,
  isLoading: false,
  error: null,
  fetched: false,

  fetchVersion: async () => {
    if (get().fetched) return; // Only fetch once per app run
    set({ isLoading: true, error: null });
    try {
      const response = await apiClient.get('/version');
      set({ version: response, isLoading: false, fetched: true });
    } catch (error) {
      set({ error: error.message || 'Failed to fetch version', isLoading: false, fetched: true });
    }
  }
}));
